<template>
  <div>
    <l-map
      ref="leafletMap"
      style="height: 505px"
      v-model:zoom="zoom"
      v-model="zoom"
      :options="mapOptions"
      :bounds="mapBounds"
      :center="center"
      @click="mouseClicked"
      @ready="mapIsReady"
    >
      <l-tile-layer
        url="https://{s}.tile.osm.org/{z}/{x}/{y}.png"
        layer-type="base"
        name="OpenStreetMap"
        :attribution="attribution"
      ></l-tile-layer>

      <l-control position="bottomleft">
        <div class="flex items-center gap-2 bg-gray-100 p-2">
          <!-- reset polygon button -->
          <button
            class="map-button"
            @click="resetVertexes"
            title="清除搜尋區域"
            type="button"
          >
            <img src="@/assets/reset.png" alt="重設框選" />
          </button>

          <!-- polygon tool button -->
          <button
            class="map-button"
            @click="setPolygonMode(true)"
            :class="isPolygon ? 'border border-indigo-900 p-1 rounded-sm' : ''"
            title="點擊地圖位置新增節點，建立多邊形搜尋區域"
            type="button"
          >
            <img src="@/assets/polygon.png" alt="多邊形框選" />
          </button>

          <!-- rectangle tool button -->
          <button
            class="map-button"
            @click="setPolygonMode(false)"
            :class="!isPolygon ? 'border border-indigo-900 p-1 rounded-sm' : ''"
            title="點擊地圖位置新增節點，以所有節點最大涵蓋範圍建立矩形搜尋區域"
            type="button"
          >
            <img src="@/assets/rectangular.png" alt="矩形框選" />
          </button>
        </div>
      </l-control>

      <!-- polygon vertexes -->
      <div v-for="(latlng, index) in vertexes" :key="index">
        <l-marker :lat-lng="latlng" :icon="vertexIcon" />
      </div>

      <!-- polygon -->
      <l-polygon
        v-if="isPolygon"
        :lat-lngs="vertexes"
        :fill="true"
        :fillOpacity="0.5"
        color="#41b782"
        fillColor="#41b782"
      />
      <!-- rectangle -->
      <div v-else>
        <l-rectangle
          v-if="rectangleBounds"
          :bounds="rectangleBounds"
          :fill="true"
          color="#35495d"
        />
      </div>
    </l-map>
  </div>
</template>

<script>
// DON'T load Leaflet components here!
// Its CSS is needed though, if not imported elsewhere in your application.
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import Utils from "@/utils/index";

import {
  LMap,
  LTileLayer,
  LPolygon,
  LRectangle,
  LMarker,
  LControl,
} from "@vue-leaflet/vue-leaflet";

export default {
  components: {
    LMap,
    LTileLayer,
    LPolygon,
    LRectangle,
    LMarker,
    LControl,
  },

  data() {
    return {
      isPolygon: true,
      vertexes: [], // 多邊形框選範圍節點座標

      // map attributes
      mapOptions: {
        scrollWheelZoom: false,
      },
      zoom: 7,
      center: [24, 121],
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      vertexIcon: L.icon({
        iconUrl: require("@/assets/polygon-vertex.png"),
        iconSize: [24, 24],
      }),
      mapBounds: null,
    };
  },

  computed: {
    // 計算框選範圍節點座標的矩形範圍
    rectangleBounds() {
      return Utils.rectangleBounds(this.vertexes);
    },
  },

  mounted() {
    // 從 vuex 複製 vertexes (不可直接 assign)
    this.vertexes = [];
    this.$store.state.search.map.vertexes.forEach((element) => {
      this.vertexes.push(element);
    });

    this.isPolygon = this.$store.state.search.map.isPolygon;
  },

  methods: {
    // 地圖準備好時呼叫此 method
    mapIsReady() {
      if (this.vertexes.length >= 3) {
        this.mapBounds = Utils.mapBounds(this.vertexes);
      } else {
        this.mapBounds = null;
      }
    },

    // 設定框選方式
    setPolygonMode(isPolygon) {
      this.isPolygon = isPolygon;
      this.$store.commit("search/setPolygonMode", isPolygon);
    },

    // 儲存目前框選的節點
    setVertexes() {
      this.$store.commit("search/setVertexes", this.vertexes);
    },

    // 清除框選範圍節點
    resetVertexes() {
      this.vertexes = [];
      this.$store.commit("search/resetVertexes");
    },

    // 地圖上滑鼠點擊事件
    mouseClicked(event) {
      if (event.latlng !== undefined) {
        // 加入點擊位置座標為多邊形節點
        this.vertexes.push(event.latlng);

        // 在 vertexes 加上項目時 polygon 不會即時渲染，因為只是陣列的內容改變，
        // vertexes 所參考的位址仍為原位址。故在此產生一陣列，先複製 vertexes 內容後，
        // 再重新設定 vertexes 為此新陣列，此時 vertexes 的變動即可觸發 polygon 渲染。
        const temp = [];
        this.vertexes.forEach((element) => {
          temp.push(element);
        });
        this.vertexes = temp;
      }
    },
  },
};
</script>
